import { FormGroup } from '@angular/forms';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseCanDeactivateComponent } from './base-deactivate';

@Component({
	selector: 'app-form-can-deactivate',
	template: '',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
})
export abstract class FormCanDeactivateComponent extends BaseCanDeactivateComponent {
	abstract get form(): FormGroup;

	canDeactivate(): boolean {
		return !this.form.dirty;
	}
}
